module.exports = __webpack_public_path__ + "static/media/construction.3d705dde.png";